import React from 'react';
import {Button, Modal, ModalBody, ModalFooter, ModalHeader} from 'reactstrap';
import "./index.css";
import {Player} from "video-react";
import PropTypes from "prop-types";
import "video-react/dist/video-react.css";
import {VideoPlayer} from "../../../../clipstore/broadcaster/library/video-player";

const VideoPlayerModal = (props) => {
    const videoJsOptions = {
        autoplay: true,
        controls: true,
        // poster:props.video.thumbnail_url,
        sources: [{
            src: props.video.url,
        }],
        aspectRatio:"16:9"
    }
    return (
        <Modal isOpen={props.isOpen} toggle={() => props.hideVideoPlayerModal()}
               className="video-player-modal">
            <ModalHeader className="border-0 ">
                <span className="text-center mb-2 video-player-modal-title">
                    {
                        props.video.title
                    }
                </span>
            </ModalHeader>
            <ModalBody className="justify-content-center">
                {/*<Player>*/}
                {/*    <source src={props.video.url}/>*/}
                {/*</Player>*/}
                <VideoPlayer { ...videoJsOptions } />
            </ModalBody>
            <ModalFooter className="border-0 justify-content-center">
                <Button
                    color="primary"
                    className="video-player-modal-ok-btn px-5"
                    onClick={() => {
                        props.action.click()
                        props.hideVideoPlayerModal();
                    }}
                >
                        <span className="video-player-modal-ok-btn-text">
                            {
                                props.action.text
                            }
                        </span>
                </Button>
            </ModalFooter>
        </Modal>
    );
}

VideoPlayerModal.propTypes = {
    video: PropTypes.object,
    action: PropTypes.object,
    isOpen: PropTypes.bool,
    hideCommonModal: PropTypes.func,
};

// Specifies the default values for props:
VideoPlayerModal.defaultProps = {
    "video": null,
    action: {
        text: "OK",
        click: () => {
        }
    },
    isOpen: false,
    hideVideoPlayerModal: () => {
    }
};

export default VideoPlayerModal;